export const firebaseConfig = {
  apiKey: "AIzaSyB1JHq-x9fdBoXCKwaI9ITsfcKw_0lW9FM",
  authDomain: "pelvic-plan-two.firebaseapp.com",
  projectId: "pelvic-plan-two",
  storageBucket: "pelvic-plan-two.appspot.com",
  messagingSenderId: "967913928194",
  appId: "1:967913928194:web:19fd7143069de7a2d1191b",
  measurementId: "G-M49XG0ZYF3",
};
